"use client";

import { useTranslations } from "next-intl";
import { ArrowLeft } from "lucide-react";

export function PrivacyPage() {
  const t = useTranslations("legal");

  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <button
          onClick={() => window.history.back()}
          className="mb-8 inline-flex items-center gap-2 text-base text-ink-mute transition-colors hover:text-ink"
        >
          <ArrowLeft size={20} />
          {t("back")}
        </button>

        <h1 className="text-3xl font-bold tracking-tight text-ink">
          {t("privacy.title")}
        </h1>
        <p className="mt-2 text-sm text-ink-mute">
          {t("privacy.lastUpdated")}
        </p>

        <div className="mt-8 space-y-8">
          <Section title={t("privacy.introTitle")}>
            <p>{t("privacy.introText")}</p>
          </Section>

          <Section title={t("privacy.collectTitle")}>
            <p>{t("privacy.collectText")}</p>
            <ul className="mt-3 list-disc space-y-1 pl-5">
              <li>{t("privacy.collectItem1")}</li>
              <li>{t("privacy.collectItem2")}</li>
              <li>{t("privacy.collectItem3")}</li>
              <li>{t("privacy.collectItem4")}</li>
            </ul>
          </Section>

          <Section title={t("privacy.useTitle")}>
            <p>{t("privacy.useText")}</p>
            <ul className="mt-3 list-disc space-y-1 pl-5">
              <li>{t("privacy.useItem1")}</li>
              <li>{t("privacy.useItem2")}</li>
              <li>{t("privacy.useItem3")}</li>
              <li>{t("privacy.useItem4")}</li>
            </ul>
          </Section>

          <Section title={t("privacy.storageTitle")}>
            <p>{t("privacy.storageText")}</p>
          </Section>

          <Section title={t("privacy.securityTitle")}>
            <p>{t("privacy.securityText")}</p>
          </Section>

          <Section title={t("privacy.sharingTitle")}>
            <p>{t("privacy.sharingText")}</p>
            <ul className="mt-3 list-disc space-y-1 pl-5">
              <li>{t("privacy.sharingItem1")}</li>
              <li>{t("privacy.sharingItem2")}</li>
              <li>{t("privacy.sharingItem3")}</li>
            </ul>
            <p className="mt-3">{t("privacy.sharingNote")}</p>
          </Section>

          <Section title={t("privacy.rightsTitle")}>
            <p>{t("privacy.rightsText")}</p>
            <ul className="mt-3 list-disc space-y-1 pl-5">
              <li>{t("privacy.rightsItem1")}</li>
              <li>{t("privacy.rightsItem2")}</li>
              <li>{t("privacy.rightsItem3")}</li>
              <li>{t("privacy.rightsItem4")}</li>
            </ul>
          </Section>

          <Section title={t("privacy.cookiesTitle")}>
            <p>{t("privacy.cookiesText")}</p>
          </Section>

          <Section title={t("privacy.changesTitle")}>
            <p>{t("privacy.changesText")}</p>
          </Section>

          <Section title={t("privacy.contactTitle")}>
            <p>{t("privacy.contactText")}</p>
          </Section>
        </div>
      </div>
    </div>
  );
}

function Section({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <section>
      <h2 className="text-lg font-semibold text-ink">{title}</h2>
      <div className="mt-2 text-sm leading-relaxed text-ink-dim">
        {children}
      </div>
    </section>
  );
}
